<template>
  <div class="card shadow-sm border-0">
    <div class="card-header bg-white d-flex justify-content-between align-items-center">
      <h5 class="mb-0 text-primary">Supplier Statement</h5>
      <div>
        <button v-if="filters.supplier_id" @click="downloadPDF" class="btn btn-outline-primary">
          <i class="bi bi-download mr-1"></i> Download PDF
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="form-row mb-3">
        <div class="col-md-4">
          <label>Supplier</label>
          <select v-model="filters.supplier_id" class="form-control" @change="fetchStatement">
            <option value="">Select Supplier</option>
            <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">
              {{ supplier.name }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label>Date range</label>
          <date-range-picker :auto-apply="true" :ranges="false" :append-to-body="true" v-model="dateRangePicker" class="custom-width-datepicker">
            <template #input="picker">
              <span v-if="picker.startDate && picker.endDate">{{ formatPickerDate(picker.startDate) }} - {{ formatPickerDate(picker.endDate) }}</span>
              <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Select date range</span>
            </template>
          </date-range-picker>
        </div>
      </div>

      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
      </div>

      <div v-else-if="supplierStatement">

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead class="thead-light">
              <tr>
                <th>Date</th>
                <th>Reference</th>
                <th>Description</th>
                <th class="text-right">Debit</th>
                <th class="text-right">Credit</th>
                <th class="text-right">Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(txn, index) in supplierStatement.transactions" :key="index">
                <td>{{ formatDate(txn.date) }}</td>
                <td>{{ txn.reference }}</td>
                <td>{{ txn.description }}</td>
                <td class="text-right" v-if="txn.debit">{{ txn.debit }}</td>
                <td class="text-right" v-else></td>
                <td class="text-right" v-if="txn.credit">{{ txn.credit }}</td>
                <td class="text-right" v-else></td>
                <td class="text-right">{{ txn.balance }}</td>
              </tr>
              <tr class="font-weight-bold bg-light">
                <td colspan="5" class="text-right">Closing Balance</td>
                <td class="text-right">{{ supplierStatement.closing_balance }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="supplierStatement.transactions.length === 0" class="text-center text-muted">
          No transactions found for the selected period.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker';
import { downloadPdf } from '../../services/pdfDownload';

export default {
  components: { DateRangePicker },
  data() {
    return {
      suppliers: [],
      supplierStatement: null,
      filters: {
        supplier_id: '',
        from: '',
        to: ''
      },
      loading: false
    };
  },
  computed: {
    // closingBalance() {
    //   if (this.supplierStatement.transactions.length) {
    //     console.log()
    //     return this.supplierStatement.transactions[this.supplierStatement.transactions.length - 1].balance;
    //   }
    //   return '0.00';
    // },

    supplierId() {
        const params = new URLSearchParams(window.location.search);
        return params.get('id');
    },

    dateRangePicker: {
      get() {
        return {
          startDate: this.filters.from ? new Date(this.filters.from) : null,
          endDate: this.filters.to ? new Date(this.filters.to) : null,
        };
      },
      set(val) {
        this.filters.from = val && val.startDate ? moment(val.startDate).format('YYYY-MM-DD') : '';
        this.filters.to = val && val.endDate ? moment(val.endDate).format('YYYY-MM-DD') : '';
        this.fetchStatement();
      },
    },

  },
  methods: {
    formatPickerDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    },
    fetchSuppliers() {
      axios.get('/api/reports/suppliers')
        .then(res => {
          this.suppliers = res.data;
        });
    },
    fetchStatement() {
        let supplier_id = this.supplierId
      if (this.filters.supplier_id)
      {
        supplier_id = this.filters.supplier_id
      }
      this.loading = true;
      axios.get('/api/suppliers/statement', { params: { supplier_id: supplier_id, from: this.filters.from, to: this.filters.to } })
        .then(res => {
          this.supplierStatement = res.data;

        })
        .finally(() => this.loading = false);
    },
    async downloadPDF() {
      const params = new URLSearchParams({ supplier_id: this.filters.supplier_id, from: this.filters.from, to: this.filters.to });
      const supplier = this.suppliers.find(s => s.id === this.filters.supplier_id);
      const name = ((supplier && supplier.name) || 'supplier').replace(/[^a-z0-9]+/gi, '-');
      try {
        await downloadPdf(`/supplier-statement/pdf?${params.toString()}`, `Statement-${name}.pdf`);
      } catch (e) {
        this.$toasts.push({ type: 'error', message: 'Could not download the statement. Please try again.' });
      }
    },
    async downloadExcel() {
      window.open(`/api/suppliers/statement/excel?supplier_id=${this.filters.supplier_id}&from=${this.filters.from}&to=${this.filters.to}`);
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  mounted() {
    this.fetchSuppliers()
    const query = new URLSearchParams(window.location.search);
    this.filters.from = query.get('from') || '';
    this.filters.to = query.get('to') || '';
    if(this.supplierId)
  {
    this.filters.supplier_id = this.supplierId
    this.fetchStatement()
  }else{
    console.log(this.supplierId,"heeey")
  }
  }
};
</script>
